import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import rajpur_ashram from "../images/rajpur_ashram.png";
import ashram_logo_8 from "../images/ashram_logo_8.png";
import "../styles/App.css";

const Header = () => {
  return (
    <>
      <div className="header">
        <Link to="/">
          <img
            className="ashram-logo"
            src={ashram_logo_8}
            alt="Brahm Vidyalaya and Ashram logo"
          />
        </Link>
        <div className="brahm-vidyalaya-header-image">
          <img
            src={rajpur_ashram}
            alt="Rajpur ashram"
            height="100px"
            width="100px"
          />
        </div>
      </div>
      <Navbar />
    </>
  );
};
export default Header;
